import PropTypes from 'prop-types';

export default PropTypes.shape({
  addLayer: PropTypes.func.isRequired,
  removeLayer: PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-leaflet/es/propTypes/layerContainer.js
// module id = 72
// module chunks = 0